<template>
  <live-page>
    <chat-page slot="chat" />
  </live-page>
</template>

<script>
import LivePage from "./Index.vue";
import ChatPage from "../new-chat/ChatPageWeb.vue";
export default {
  components: {
    LivePage,
    ChatPage,
  },
};
</script>
